import { faClipboardCheck, faTruck, faWarehouse, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProgressBar, Step } from "react-step-progress-bar";

interface Props {
    status: string | undefined
}

const StatusProgressBar = ({status}: Props) => {

    if (status === undefined) return <></>;

    var stepPercentage = 0;
    if (status === "pending approval") {
        stepPercentage = 25;
    } else if (status.includes('partially fulfilled')) {
        stepPercentage = 70;
    } else if (status === "pending fulfillment") {
        stepPercentage = 70;
    } else if (status === 'billed' || status === 'pending billing') {
        stepPercentage = 100;
    } else {
        stepPercentage = 0;
    }

    return (
        <ProgressBar percent={stepPercentage} filledBackground="linear-gradient(to right, var(--bcd-progress-start), var(--bcd-progress-end))">
            <Step>
                {({ accomplished }) => (
                    <div className={`indexedStep ${accomplished ? "accomplished" : ""}`}>
                        <FontAwesomeIcon icon={faWarehouse} />
                    </div>
                )}
            </Step>
            {
                status.includes('partially fulfilled')
                    ?
                    <Step>
                        {({ accomplished }) => (
                            <div className={`indexedStep ${accomplished ? "accomplished" : ""}`}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        )}
                    </Step>
                    :
                    <Step>
                        {({ accomplished }) => (
                            <div className={`indexedStep ${accomplished ? "accomplished" : ""}`}>
                                <FontAwesomeIcon icon={faClipboardCheck} />
                            </div>
                        )}
                    </Step>
            }
            <Step>
                {({ accomplished }) => (
                    <div className={`indexedStep ${accomplished ? "accomplished" : ""}`}>
                        <FontAwesomeIcon icon={faTruck} />
                    </div>
                )}
            </Step>
        </ProgressBar>
    );
};

export default StatusProgressBar;